import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { name: "NoticeDetail" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "hstack gap-2" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "row mt-2" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-11 offset-1" }
const _hoisted_13 = {
  class: "border border-1 rounded bg-light p-2",
  style: {"min-height":"100px"}
}
const _hoisted_14 = {
  id: "divRecipients",
  class: "mt-2"
}
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col-8" }
const _hoisted_17 = {
  key: 1,
  class: "container-fluid p-0"
}
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-11 offset-1" }
const _hoisted_20 = { class: "w-100 text-center" }
const _hoisted_21 = { class: "w-100 text-center" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = { class: "row mt-2" }
const _hoisted_24 = { class: "col-sm-12" }
const _hoisted_25 = { class: "hstack gap-2 align-end" }
const _hoisted_26 = ["disabled"]

import {computed, ref, onMounted, watch} from "vue";
import {BTableColumn, BTableOptions} from "../BTable/BTable.types";
import {BFilter, BFilterableField} from "../BFilterEditor/BFilterEditor.types";
import BGrid from "../BGrid/BGrid.vue";
import {useNoticeStore} from "@/stores/noticeStore";
import {NoticeItem} from "./types";
import InformationModal from "../Misc/InformationModal.vue";
import {useOriStore} from "../../stores/oriStore";
import {Notice} from "@/types";
import hasPermission from "@/composable/permissionHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeDetails',
  props: {
    item: {},
    ori: {},
    notification: {},
    showNoticeDetailsModal: { type: Boolean }
  },
  emits: ["submit", "dismiss"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const noticeStore = useNoticeStore();
const oriStore = useOriStore();
oriStore.dataset = undefined;
var showModal = ref(false);
var oriLabel = ref(undefined as string | undefined);
var emailLabel = ref("");
var uniqueRecipientAgencyCount = ref(0);

const columns = [
    {key: "agency", text: "Agency", sortable: false, value: (item) => item.agency},
    {key: "email", text: "Email", sortable: false, value: (item) => item.email, class: (item) => ["column-wrap"]},
    {
        key: "is_dismissed",
        text: "Dismissed",
        sortable: false,
        value: (item) => item.is_dismissed,
        columnClass: ["text-wrap"],
        class: (item) => ["text-wrap"],
    },
] as BTableColumn[];

var isDismissable = computed(() => {
    if (props.notification != undefined) {
        return !props.notification?.is_dismissed;
    }

    return !props.item.is_dismissed;
});

function getAgencyLabel() {
    if (props.ori != undefined) {
        oriStore.getOri(props.ori).then(() => {
            oriLabel.value = oriStore.ori?.ori_name ?? "";
        });
    } else {
        oriLabel.value = undefined;
    }
}

async function getRecipients() {
    if (props.item.id) {
        await noticeStore.getNoticeRecipients(props.item.id);

        uniqueRecipientAgencyCount.value = getDistinctCount(noticeStore.recipients.map((m) => m.agency));

        if (uniqueRecipientAgencyCount.value == 1) {
            let ori = props.ori;

            if (!ori) {
                let agencyLabel = noticeStore.recipients[0].agency;
                ori = agencyLabel.substring(agencyLabel.indexOf("(") + 1, agencyLabel.length - 1);
            }

            emailLabel.value = await noticeStore.getNoticeRecipientsForOriAsString(props.item.id, ori);
        }
    }
}

function getDistinctCount(array: string[]): number {
    return new Set(array).size;
}

function showDismissModal() {
    showModal.value = true;
}

async function submitDismiss() {
    if (props.notification != undefined) {
        await noticeStore.dismissNotice(props.notification.id);
    } else {
        await noticeStore.dismissNoticesByLogId(props.item.id, undefined);
    }

    if (props.ori) {
        noticeStore.list(props.ori);
    }

    showModal.value = false;
    emit("submit");
}

function handleModalDismiss() {
    showModal.value = false;
}

function handleNoticeDetailsModalDismiss() {
    emit("dismiss");
}

function loadData() {
    noticeStore.resetRecipients();

    if (props.ori) {
        noticeStore.recipientFilterOptions = {filters: [{property: "agency", operation: "eq", value: props.ori}]};
    }

    getRecipients();
    getAgencyLabel();
}

watch(
    () => props.item.id,
    (val) => {
        loadData();
    }
);

watch(
    () => props.ori,
    (val) => {
        loadData();
    }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(InformationModal, {
      title: `Notice Details - ${props.item.description}`,
      "show-modal": _ctx.showNoticeDetailsModal,
      "show-footer": true,
      width: "38.5em",
      onDismiss: _cache[5] || (_cache[5] = ($event: any) => (handleNoticeDetailsModalDismiss()))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InformationModal, {
            title: "Dismiss Confirmation",
            "show-footer": true,
            "show-modal": _unref(showModal),
            onDismiss: handleModalDismiss
          }, {
            body: _withCtx(() => [
              (_unref(uniqueRecipientAgencyCount) > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Notice will be dismissed for all authorized recipients. Are you sure you want to dismiss this notice?"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "Are you sure you want to dismiss this notice for " + _toDisplayString(_unref(oriLabel) ?? props.item.ori) + "?", 1))
            ]),
            footer: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary w-50",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (submitDismiss()), ["prevent"]))
                }, " Ok "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary w-50",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleModalDismiss()), ["prevent"]))
                }, " Cancel ")
              ])
            ]),
            _: 1
          }, 8, ["show-modal"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-2" }, [
                _createElementVNode("label", { class: "fw-bold" }, "Agency:")
              ], -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(oriLabel) ?? props.item.ori), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-2" }, [
                _createElementVNode("label", {
                  id: "lblDate",
                  class: "fw-bold"
                }, "Date:")
              ], -1)),
              _createElementVNode("div", _hoisted_10, _toDisplayString(props.item.run_date), 1)
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row mt-2" }, [
              _createElementVNode("div", { class: "col" }, [
                _createElementVNode("label", {
                  for: "body",
                  "aria-label": "Main content of the notice",
                  class: "fw-bold"
                }, "Body:")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", _hoisted_13, _toDisplayString(props.item.message), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_unref(uniqueRecipientAgencyCount) == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-4" }, [
                      _createElementVNode("label", {
                        id: "lblRecipients",
                        class: "align-self-baseline fw-bold"
                      }, "Email Recipient(s):")
                    ], -1)),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(emailLabel)), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row" }, [
                      _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("label", {
                          id: "lblRecipients",
                          class: "fw-bold"
                        }, " Email Recipient(s): ")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(BGrid, {
                          caption: "Recipient list",
                          class: "recipient-grid",
                          items: _unref(noticeStore).recipients,
                          columns: columns,
                          filterableFields: _unref(noticeStore).recipientFilterableFields,
                          filterOptions: _unref(noticeStore).recipientFilterOptions,
                          tableOptions: _unref(noticeStore).recipientTableOptions,
                          "show-filter": true,
                          "show-paging": false,
                          onOptionChange: _cache[2] || (_cache[2] = ($event: any) => (_unref(noticeStore).getNoticeRecipients(props.item.id)))
                        }, {
                          "header.is_dismissed": _withCtx(({column}) => [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(column.text), 1)
                          ]),
                          "cell.is_dismissed": _withCtx(({item, column}) => [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("input", {
                                class: "",
                                disabled: "true",
                                readonly: "",
                                type: "checkbox",
                                checked: item.is_dismissed
                              }, null, 8, _hoisted_22)
                            ])
                          ]),
                          _: 1
                        }, 8, ["items", "filterableFields", "filterOptions", "tableOptions"])
                      ])
                    ])
                  ]))
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (handleNoticeDetailsModalDismiss()), ["prevent"]))
              }, " Cancel "),
              (_unref(hasPermission)('DismissNotices'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "btnDismiss",
                    class: "btn btn-primary confirm-remove margin-right-5",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (showDismissModal()), ["prevent"])),
                    disabled: !_unref(isDismissable)
                  }, " Dismiss Notice ", 8, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "show-modal"])
  ]))
}
}

})